import { Component } from "react";
import * as React from "react";

import "./ImageWithText.css"

interface IImageWithTextProps {
    header: string;
    text: string | string[];
    imagePosition: "left" | "right";
    imgSrc: string;
    style?: React.CSSProperties;
    soldOut?: boolean;
}

export class ImageWithText extends Component<IImageWithTextProps> {
    public render() {
        const img = (
            <div className="cell medium-5">
                <img src={this.props.imgSrc} alt="" style={{ height: "100%", width: "100%", objectFit: "cover" }}/>
            </div>
        );

        const textItems = (Array.isArray(this.props.text)) ?
            this.props.text.map((t, i) => <li key={i}>{t}</li>) :
            <li>{this.props.text}</li>

        let title;
        if (this.props.soldOut) {
            title = (<span className="title">{this.props.header} <span className="flag sold-out">Ausverkauft</span></span>)
        } else {
            title = (<span className="title">{this.props.header}</span>)
        }

        const text = (
            <div className="in-action-card cell medium-7 text-center" style={{ padding: "1rem" }}>
                {title}
                <hr/>
                <ul>{textItems}</ul>
            </div>
        )

        const content = (this.props.imagePosition === "left") ?
            (<div className="grid-x align-middle" style={{ backgroundColor: "#fefefe" }}>{img}{text}</div>) :
            (<div className="grid-x align-middle" style={{ backgroundColor: "#fefefe" }}>{text}{img}</div>);

        return (
            <div className="image-with-text grid-container" style={this.props.style}>
                {content}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/visual/ImageWithText.tsx